import React, { Component } from 'react';
import { defaultStyles } from '../util/styles';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import { withStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
  root: {
    position: 'relative',
  },
  dropdown: {
    position: 'absolute',
    top: 58,
    right: 0,
    left: 0,
    zIndex: 10,
    padding: theme.spacing(1),
  },
  ...defaultStyles(theme),
});

class AddressAutocomplete extends Component {

  constructor(props) {
    super(props);

    this.state = {
      address: '',
    };

    this.inputRef = React.createRef();
  }

  onChange = event => this.setState({address: event});

  onSelect = event => {
    if (event !== this.state.address) {
      this.setState({address: event});
    }

    geocodeByAddress(event)
      .then(results => {
        const address_components = {
          street_number: this.getTypeFromComponents(results[0].address_components, 'street_number'),
          route: this.getTypeFromComponents(results[0].address_components, 'route'),
          postal_town: this.getTypeFromComponents(results[0].address_components, 'postal_town'),
          postal_code: this.getTypeFromComponents(results[0].address_components, 'postal_code'),
          country: this.getTypeFromComponents(results[0].address_components, 'country'),
        };
        this.props.onSelected(address_components);
      })
      .catch(error => console.error('Error', error));
  };

  getTypeFromComponents = (components, key) => {
    for (let c of components) {
      for (let type of c.types) {
        if (type === key) return String(c.long_name);
      }
    }
    return null;
  };

  render() {
    const {classes} = this.props;

    return <PlacesAutocomplete
      value={this.state.address}
      onChange={this.onChange}
      onSelect={this.onSelect}
      searchOptions={{
        types: ['address'],
      }}
    >
      {({getInputProps, suggestions, getSuggestionItemProps, loading}) => {
        const showSuggestions = loading || suggestions.length > 0;

        return <div className={classes.root}>
          <TextField
            variant='outlined'
            fullWidth
            value={this.state.address}
            label={this.props.label}
            required={this.props.required}
            inputProps={getInputProps({
              className: 'location-search-input',
            })}/>
          {showSuggestions ? <Paper className={classes.dropdown}>
            <List>
              {loading && <ListItem key='loading'><CircularProgress/></ListItem>}
              {suggestions.map(suggestion => {
                return <ListItem
                  {...getSuggestionItemProps(suggestion, {
                    key: suggestion.placeId,
                    selected: suggestion.active,
                    button: true,
                  })}
                  key={suggestion.placeId}
                >
                  <ListItemText>
                    {suggestion.description}
                  </ListItemText>
                </ListItem>;

              })}
            </List>
          </Paper> : null}
        </div>;
      }}
    </PlacesAutocomplete>;
  }
}

export default withStyles(styles)(AddressAutocomplete);